<template>
<div class="row">
  <div class="col-md-6 offset-md-3">
    <h1>About this project</h1>
    <p>
      Taking advantage of Google Firebase and hosting. This project is 100% 'serverless' in a sense that there is no server and infrastructure to take care of.
      It uses VueJS and Bootstrap to call the Firebase DB functions.
    </p>
    <h3>Work in progress:</h3>
    <ul>
      <li>Update the alert box to something better</li>
      <li>Users login and authentication</li>
      <li>Search</li>
      <li>Use Quasar instead of Vue + Bootstrap</li>
      <li>Test deployment</li>
    </ul>
    <p>  
      Inspired by <a href="https://www.positronx.io/vue-js-firebase-build-vue-crud-app-with-cloud-firestore/" target="_blank" rel="noopener">PositronX article</a>.
    </p>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
// <style scoped lang="scss">
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
// </style>
